import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;
export const ContentContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
export const HeaderConfiguration = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 3px;
  margin-top: -10px;

  span {
    margin-left: 10px;

    font-family: "Poppins" !important;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    display: flex;
    align-items: center;
    color: #ffffff;
  }
`;
export const Avatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 57px;
  height: 57px;
  margin-left: 5px;
  border-radius: 50%;
  background: #c4c4c4;

  font-family: "Poppins" !important;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;

  img {
    width: 57px;
    height: 57px;
    border-radius: 50%;
  }
`;
export const InputContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 40px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #a7a7a7;
  box-sizing: border-box;
  padding: 10px;

  span {
    display: flex;
    align-items: center;
    justify-content: center;

    font-family: "Poppins" !important;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    color: #4d4d4d;
  }
`;
export const ContentBackground = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 322px;
  height: 350px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  background: linear-gradient(0deg, #a7a7a7, #a7a7a7), #a7a7a7;
  border-radius: 5px;
`;
export const ButtonSecondaryContainer = styled.button`
  position: absolute;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 200px;
  background: transparent;
  border-radius: 5px;
  border: none;
  bottom: 2px;
  right: 50%;
  transform: translateX(50%);
`;

export const ButtonAction = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  cursor: pointer;

  background: linear-gradient(0deg, #5abde7, #5abde7), #a7a7a7;
  ${(props) =>
    props.check &&
    css`
      opacity: 0.8;
      background: linear-gradient(0deg, #ff0000, #ff0000), #5abde7;
    `}
  border: none;
  border-radius: 5px;
`;
export const ButtonCancel = styled.button`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 58px;
  height: 45px;
  left: 50%;
  bottom: 60px;
  transform: translateX(-50%);
  cursor: pointer;
  border: none;
  border-radius: 5px;
  background-color: #ff0000;
`;
